import * as React from 'react';
import { Popup, PopupPlacement } from '../Popup/Popup';

export type DropdownProps = {
    isOpen: boolean;
    parentRef: React.RefObject<HTMLElement>;
    portalRoot?: string;
    placement?: PopupPlacement;
    fullWidth?: boolean;
    onClose?: () => void;
};

export const Dropdown: React.FunctionComponent<DropdownProps> = ({
    isOpen,
    onClose,
    parentRef,
    portalRoot,
    placement = 'bottom-start',
    fullWidth,
    children,
}) => {
    return (
        <Popup
            isOpen={isOpen}
            onClose={onClose}
            portalRoot={portalRoot}
            parentRef={parentRef}
            hasCaret={false}
            hasShadow={true}
            placement={placement}
            fullWidth={fullWidth}
        >
            {children}
        </Popup>
    );
};
